import type { PointArray } from '../types/contour-definition-array-type';

import { featureCollection, intersect } from '@turf/turf';

import { convertArrayToPointArray } from './convertArrayToPointArray';
import { getSimpleArrayArea } from './getSimpleArrayArea';
import { pointArrayToPolygon } from './turf-utils';

/**
 *
 * @param pointArray1
 * @param pointArray2
 * @returns Returns the intersection of two arrays. If multiple intersections exist, returns the biggest.
 */
export function getPolygonIntersection(
  pointArray1: PointArray,
  pointArray2: PointArray,
): PointArray {
  const polygon1 = pointArrayToPolygon(pointArray1);
  const polygon2 = pointArrayToPolygon(pointArray2);

  const intersectPolygon = intersect(featureCollection([polygon1, polygon2]));

  // If the type of intersectPolygon.geometry is MultiPolygon that means
  // the input polygons intersect multiple times
  if (intersectPolygon) {
    if (intersectPolygon.geometry.type === 'Polygon') {
      return convertArrayToPointArray(intersectPolygon.geometry.coordinates[0]);
    }
    if (intersectPolygon.geometry.type === 'MultiPolygon') {
      const sortedAreas = intersectPolygon.geometry.coordinates.sort(
        (a, b) => getSimpleArrayArea(b[0]) - getSimpleArrayArea(a[0]),
      );
      const biggestArea = sortedAreas[0][0];
      return convertArrayToPointArray(biggestArea);
    }
  }

  return [];
}
